import { $$, on, doc } from './util.js';

/* 9. GENERIC DISCLOSURE TOGGLES (path cards "Browse all sections", FRD 6.2) */
export function initDisclosures() {
	$$('[data-disclosure]').forEach(function (btn) {
		on(btn, 'click', function () {
			var target = doc.getElementById(btn.getAttribute('data-disclosure'));
			if (!target) { return; }
			var open = btn.getAttribute('aria-expanded') === 'true';
			btn.setAttribute('aria-expanded', open ? 'false' : 'true');
			target.classList.toggle('open', !open);
		});
	});
}
